import { ShareImageButton } from "@/components/ShareCard";
import { useLang } from "@/context/LanguageContext";

const S = 1080;

const drawCouponCard = async (pct, lang) => {
  await document.fonts?.ready;
  const hi = lang === "hi";
  const c = document.createElement("canvas");
  c.width = S; c.height = S;
  const x = c.getContext("2d");
  x.fillStyle = "#0A192F"; x.fillRect(0, 0, S, S);
  const glow = (cx, cy, r, col) => { const g = x.createRadialGradient(cx, cy, 0, cx, cy, r); g.addColorStop(0, col); g.addColorStop(1, "rgba(10,25,47,0)"); x.fillStyle = g; x.fillRect(0, 0, S, S); };
  glow(900, 160, 520, "rgba(255,59,59,0.55)"); glow(120, 980, 520, "rgba(0,229,255,0.35)");
  x.strokeStyle = "rgba(255,209,102,0.9)"; x.lineWidth = 6; x.setLineDash([26, 18]);
  x.strokeRect(60, 60, S - 120, S - 120); x.setLineDash([]);
  x.textAlign = "center"; x.fillStyle = "#FFFFFF";
  x.font = "800 44px Outfit, sans-serif"; x.fillText("RoboSpark", S / 2, 170);
  x.fillStyle = "#FF6B6B"; x.font = "italic 700 34px Outfit, sans-serif";
  x.fillText(hi ? "अपने सपनों को पंख दें" : "Give Wings to Your Dreams", S / 2, 222);
  x.fillStyle = "#FFFFFF"; x.font = "800 64px Outfit, sans-serif"; x.fillText(hi ? "मुझे मिली" : "I got", S / 2, 380);
  x.fillStyle = "#FFD166"; x.font = "900 290px Outfit, sans-serif"; x.fillText(`${pct}%`, S / 2, 640);
  x.fillStyle = "#FFFFFF"; x.font = "900 96px Outfit, sans-serif"; x.fillText(hi ? "छूट!" : "OFF!", S / 2, 760);
  x.fillStyle = "#9BE9F5"; x.font = "600 36px Outfit, sans-serif";
  x.fillText(hi ? "AI • रोबोटिक्स • ड्रोन — सीखें। बनाएँ। उड़ान भरें।" : "AI • Robotics • Drones — Learn. Build. Soar.", S / 2, 850);
  x.fillStyle = "#FF3B3B"; x.beginPath(); x.roundRect(260, 890, 560, 90, 45); x.fill();
  x.fillStyle = "#FFFFFF"; x.font = "800 38px Outfit, sans-serif";
  x.fillText(hi ? "आप भी पाएँ · robospark.vip" : "Get yours · robospark.vip", S / 2, 948);
  x.fillStyle = "rgba(255,255,255,0.6)"; x.font = "500 24px Outfit, sans-serif";
  x.fillText(hi ? "नए दाखिले · 14 नवंबर 2026 तक · किट शामिल नहीं" : "New admissions · till 14 Nov 2026 · kits not included", S / 2, 1010);
  return new Promise((res) => c.toBlob(res, "image/png"));
};

export const CouponShareButton = ({ pct, refCode, testid = "coupon-share-btn" }) => {
  const { L, lang } = useLang();
  if (!pct) return null;
  const link = `${window.location.origin}/enroll${refCode ? `?ref=${refCode}` : ""}`;
  const text = L(`I just got ${pct}% off on RoboSpark's AI, Robotics & Drone classes! 🚀 Give Wings to Your Dreams. Get your own coupon (new admissions, till 14 Nov 2026): ${link}`,
    `मुझे RoboSpark की AI, रोबोटिक्स और ड्रोन कक्षाओं पर ${pct}% छूट मिली! 🚀 अपने सपनों को पंख दें। आप भी अपना कूपन पाएँ (नए दाखिले, 14 नवंबर 2026 तक): ${link}`);
  return (
    <ShareImageButton makeBlob={() => drawCouponCard(pct, lang)} fname={`robospark-${pct}-off.png`} text={text} variant="red" testid={testid}
      title={L(`Share your ${pct}% win`, `अपनी ${pct}% छूट शेयर करें`)} label={L(`Share my ${pct}% win on WhatsApp`, `WhatsApp पर ${pct}% छूट शेयर करें`)} />
  );
};
